import React, { memo } from "react";
import CmsFormSkeleton from "./CmsFormSkeleton";

const TermAndConditionSkeleton = memo(() => {
  return <CmsFormSkeleton showHistory />;
});

TermAndConditionSkeleton.displayName = "TermAndConditionSkeleton";

export default TermAndConditionSkeleton;
